import * as React from 'react';

import { navigateToSignUp } from '../routing/router-utils';
import { ModalType, ModalContext } from '../modal/ModalProvider';
import { getSessionVal, setSessionVal } from '../storage/storage-utils';
import { UserContext } from '../providers/UserProvider';
import { trackEvent } from '../analytics/tracking';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';

import styles from './footer.module.css';

const SignUpBar = () => {

  // Only display bar for anonymous users
  const { user } = React.useContext(UserContext);

  // For use with Sign In modal
  const { displayModal } = React.useContext(ModalContext);

  const handleClose = () => {
    setShowBar(false);
    setSessionVal('hideSignUpBar', true);
    trackEvent('signup_bar_close'); 
  };

  const [showBar, setShowBar] = React.useState(); 
  React.useEffect(() => {
    const disabledForSession = !!getSessionVal('hideSignUpBar');
    const disableBar = (user && !user.isAnonymous) || disabledForSession;
    if (disableBar) {
       setShowBar(false);
     } else {
       setShowBar(true);
     }
  }, [user]);

  return ( showBar
    ? <div className={styles.signUpBar}>
        <div className={styles.close} onClick={handleClose}>
          <HighlightOffRoundedIcon style={{verticalAlign:'-6px', fontSize: '22px', color: '#ccc'}} />
        </div>
        <div className={styles.text}>Ready to order?</div>
        <div className={styles.actions}>
          <span className={styles.lnk} onClick={() => {
             const navigateTo = window.location.pathname;
             displayModal(ModalType.LOGIN,{navigateTo});
             trackEvent('signup_bar_signin'); 
            }}>
            Sign in
          </span>
          {/* handles stored address or not */}
          <span className={styles.btn} onClick={() => {
            navigateToSignUp();
            trackEvent('signup_bar_signup'); 
          }}>Sign Up</span> 
        </div>
      </div>
    : null
  );
};

export default SignUpBar;